"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyModules = void 0;
var lodash_1 = require("lodash");
var fitpos_api_1 = require("../../../api/fitpos-api");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var translation_1 = __importDefault(require("@services/translation"));
var reference_object_const_1 = require("@const/reference-object.const");
var module_mapping_1 = require("@const/module.mapping");
var MyModules = /** @class */ (function () {
    function MyModules() {
        this.fitposAPI = object_service_1.ObjectService.getInstance(fitpos_api_1.FitposApi);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
    }
    MyModules.prototype.loadModule = function (customer, moduleDiv) {
        return __awaiter(this, void 0, void 0, function () {
            var contracts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.htmlModule = moduleDiv;
                        this.refObjects = module_mapping_1._AddonSelectionReferences;
                        return [4 /*yield*/, this.fitposAPI.getCustomerContractData(customer.id, 'ACTIVE')];
                    case 1:
                        contracts = _a.sent();
                        (0, reference_object_const_1._RefObjectFinder)(this.htmlModule, this.refObjects);
                        console.log('contracts', contracts);
                        this.renderModules(contracts.map(function (a) { return a.moduleContracts; }).flat());
                        return [2 /*return*/];
                }
            });
        });
    };
    MyModules.prototype.renderModules = function (boughtModules) {
        return __awaiter(this, void 0, void 0, function () {
            var container, index, _loop_1, this_1, _i, boughtModules_1, module_1;
            return __generator(this, function (_a) {
                container = this.htmlModule.querySelector('[data-ref="my-module-container"]');
                if (!container) {
                    console.error('No container for modules found: [data-ref="my-module-container"]');
                    return [2 /*return*/];
                }
                container.innerHTML = '';
                if (boughtModules.length === 0) {
                    container.appendChild(this.refObjects.refObjectNoModule.domElement.clone().get(0));
                    return [2 /*return*/];
                }
                index = 0;
                _loop_1 = function (module_1) {
                    var selectable = this_1.refObjects.refObjectSelectableModules.domElement
                        .clone()
                        .get(0);
                    selectable.querySelectorAll('[data-get]').forEach(function (a) {
                        var attr = a.getAttribute('data-get');
                        if (attr === 'price') {
                            a.innerHTML = translation_1.default.transformCurrency((0, lodash_1.get)(module_1, attr || ''));
                        }
                        else if (attr === 'count') {
                            a.innerHTML = String(index + 1);
                        }
                        else {
                            a.innerHTML = translation_1.default.t((0, lodash_1.get)(module_1, attr || ''));
                        }
                    });
                    console.log(boughtModules, 'this.selectedModules');
                    //Show price overview only if module selected
                    container.appendChild(selectable);
                    index++;
                };
                this_1 = this;
                for (_i = 0, boughtModules_1 = boughtModules; _i < boughtModules_1.length; _i++) {
                    module_1 = boughtModules_1[_i];
                    _loop_1(module_1);
                }
                return [2 /*return*/];
            });
        });
    };
    return MyModules;
}());
exports.MyModules = MyModules;
